// Generated by purs version 0.15.15
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Form_Totality from "../Restaumatic.Form.Totality/index.js";
var eq = /* #__PURE__ */ Data_Eq.eq(Restaumatic_Form_Totality.eqProofIsPartial);
var NoValue = /* #__PURE__ */ (function () {
    function NoValue(value0) {
        this.value0 = value0;
    };
    NoValue.create = function (value0) {
        return new NoValue(value0);
    };
    return NoValue;
})();
var SomeValue = /* #__PURE__ */ (function () {
    function SomeValue(value0) {
        this.value0 = value0;
    };
    SomeValue.create = function (value0) {
        return new SomeValue(value0);
    };
    return SomeValue;
})();
var showValue = function (dictShow) {
    var show = Data_Show.show(dictShow);
    return {
        show: function (v) {
            if (v instanceof NoValue) {
                return "noValue";
            };
            if (v instanceof SomeValue) {
                return "(SomeValue " + (show(v.value0) + ")");
            };
            throw new Error("Failed pattern match at Restaumatic.Form.Value (line 35, column 1 - line 37, column 54): " + [ v.constructor.name ]);
        }
    };
};
var functorValue = {
    map: function (f) {
        return function (m) {
            if (m instanceof NoValue) {
                return new NoValue(m.value0);
            };
            if (m instanceof SomeValue) {
                return new SomeValue(f(m.value0));
            };
            throw new Error("Failed pattern match at Restaumatic.Form.Value (line 0, column 0 - line 0, column 0): " + [ m.constructor.name ]);
        };
    }
};
var eqValue = function (dictEq) {
    var eq1 = Data_Eq.eq(dictEq);
    return {
        eq: function (x) {
            return function (y) {
                if (x instanceof NoValue && y instanceof NoValue) {
                    return eq(x.value0)(y.value0);
                };
                if (x instanceof SomeValue && y instanceof SomeValue) {
                    return eq1(x.value0)(y.value0);
                };
                return false;
            };
        }
    };
};
var applyValue = {
    apply: function (v) {
        return function (v1) {
            if (v instanceof NoValue) {
                return new NoValue(v.value0);
            };
            if (v1 instanceof NoValue) {
                return new NoValue(v1.value0);
            };
            if (v instanceof SomeValue && v1 instanceof SomeValue) {
                return new SomeValue(v.value0(v1.value0));
            };
            throw new Error("Failed pattern match at Restaumatic.Form.Value (line 21, column 1 - line 24, column 54): " + [ v.constructor.name, v1.constructor.name ]);
        };
    },
    Functor0: function () {
        return functorValue;
    }
};
var bindValue = {
    bind: function (v) {
        return function (v1) {
            if (v instanceof NoValue) {
                return new NoValue(v.value0);
            };
            if (v instanceof SomeValue) {
                return v1(v.value0);
            };
            throw new Error("Failed pattern match at Restaumatic.Form.Value (line 29, column 1 - line 31, column 29): " + [ v.constructor.name, v1.constructor.name ]);
        };
    },
    Apply0: function () {
        return applyValue;
    }
};
var applicativeValue = /* #__PURE__ */ (function () {
    return {
        pure: SomeValue.create,
        Apply0: function () {
            return applyValue;
        }
    };
})();
var monadValue = {
    Applicative0: function () {
        return applicativeValue;
    },
    Bind1: function () {
        return bindValue;
    }
};
var toMaybe = function (v) {
    if (v instanceof NoValue) {
        return Data_Maybe.Nothing.value;
    };
    if (v instanceof SomeValue) {
        return new Data_Maybe.Just(v.value0);
    };
    throw new Error("Failed pattern match at Restaumatic.Form.Value (line 50, column 1 - line 50, column 44): " + [ v.constructor.name ]);
};
var encodeValue = function (dictEncode) {
    return {
        encode: (function () {
            var $77 = Foreign_Generic_Class.encode(Foreign_Generic_Class.maybeEncode(dictEncode));
            return function ($78) {
                return $77(toMaybe($78));
            };
        })()
    };
};
var orElse = function (v) {
    return function (v1) {
        if (v instanceof SomeValue) {
            return new SomeValue(v.value0);
        };
        if (v instanceof NoValue) {
            return v1;
        };
        throw new Error("Failed pattern match at Restaumatic.Form.Value (line 42, column 1 - line 42, column 65): " + [ v.constructor.name, v1.constructor.name ]);
    };
};
var noValue = /* #__PURE__ */ (function () {
    return new NoValue(Restaumatic_Form_Totality.isPartial);
})();
var unsafeNoValue = noValue;
var get = function (v) {
    if (v instanceof NoValue) {
        return Restaumatic_Form_Totality.absurd(v.value0);
    };
    if (v instanceof SomeValue) {
        return v.value0;
    };
    throw new Error("Failed pattern match at Restaumatic.Form.Value (line 46, column 1 - line 46, column 38): " + [ v.constructor.name ]);
};
var elim = function (v) {
    return function (v1) {
        return function (v2) {
            if (v2 instanceof NoValue) {
                return v(v2.value0);
            };
            if (v2 instanceof SomeValue) {
                return v1(v2.value0);
            };
            throw new Error("Failed pattern match at Restaumatic.Form.Value (line 57, column 1 - line 57, column 78): " + [ v.constructor.name, v1.constructor.name, v2.constructor.name ]);
        };
    };
};
export {
    NoValue,
    SomeValue,
    orElse,
    get,
    toMaybe,
    noValue,
    elim,
    unsafeNoValue,
    eqValue,
    functorValue,
    applyValue,
    applicativeValue,
    bindValue,
    monadValue,
    showValue,
    encodeValue
};
